export default __webpack_public_path__ + "static/media/0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c.92643887.jpg";